import { Bubble } from 'js/bubbleCore/bubbles/types';
import { IPoint, IRectangle, ISpace } from 'framework/utils/math-utils';

export type EntityID = string;

export interface IEntity {
  id: EntityID;
}

export enum Place {
  Grid = "Grid",
  ShootingSpace = "ShootingSpace",
  Shooter = "Shooter",
  PopOutSpace = "PopOutSpace",
}

export enum HexGridType {
  OddR = 'oddR',
  EvenR = 'evenR',
  OddQ = 'oddQ',
  EvenQ = 'evenQ',
}

export interface IHexGridData<T> {
  type: HexGridType;
  asymetrical: boolean;
  limits: IRectangle;
  offset: IPoint;
  values: {[key: string]: T};
}

export interface IHexSpaceData<T> {
  values: T[];
  limits: ISpace;
  type: HexGridType;
  gravity: number;
}

export type BubbleMap = {[key: string]: Bubble | undefined};

export interface IShooterData {
  position: IPoint;
  bubbleSpeed: number;
  bubblesQueue: Bubble[];
  angleLimitRad: number;
}

export interface IPopOutSpaceData extends IHexSpaceData<Bubble> {
  bouncers: IBouncer[];
  pointZones: IPointZone[];
  popOutVelRange: ISpace;
}

export interface IBouncer extends IEntity {
  // REFACTOR that name - it is not size, but also position
  size: IRectangle;
}

export interface IPointZone extends IEntity {
  rect: IRectangle;
  score: number;
}

export interface IBubbleGrid extends IHexGridData<Bubble> {
  scrollSpeed: number;
  fillScrollSpeed: number;
  normalScrollSpeed: number;
  scrollFill: number;
  deathLineY: number;
}

export interface IGameState {
  score: number;
  chain: number;
  gameOver: boolean;
  firstShoot: boolean;
  time: number;
}

export interface IColorConfig {
  startSec: number;
  colors: number;
}

export interface IGameConfig {
  fireEvery: number;
  availableColors: IColorConfig[];
}

export interface IGameData {
  seed?: string | any[];
  config: IGameConfig;
  state: IGameState;
  grid: IBubbleGrid;
  shootingSpace: IHexSpaceData<Bubble>;
  popOutSpace: IPopOutSpaceData;
  shooter: IShooterData;
}

export enum Direction {
  RightDown = 'RightDown',
  RightUp = 'RightUp',
  Up = 'Up',
  LeftUp = 'LeftUp',
  LeftDown = 'LeftDown',
  Down = 'Down',
}

export const directionCubeOffsets: {[key in Direction]: [number, number, number]} = {
  [Direction.RightDown]: [1, -1, 0],
  [Direction.RightUp]: [1, 0, -1],
  [Direction.Up]: [0, 1, -1],
  [Direction.LeftUp]: [-1, 1, 0],
  [Direction.LeftDown]: [-1, 0, 1],
  [Direction.Down]: [0, -1, 1],
}